// extracted by mini-css-extract-plugin
export var card = "CardBuilder-module--card--06dd1";
export var cardBody = "CardBuilder-module--cardBody--07238";
export var cardHead = "CardBuilder-module--cardHead--7459b";
export var cardHotelTags = "CardBuilder-module--cardHotelTags--60ec2";
export var cardHotelTagsItem = "CardBuilder-module--cardHotelTagsItem--011a6";
export var cardImage = "CardBuilder-module--cardImage--f297d";
export var cardImageContainer = "CardBuilder-module--cardImageContainer--fd76b";
export var cardLink = "CardBuilder-module--cardLink--c9f45";
export var cardSponsored = "CardBuilder-module--cardSponsored--812f5";
export var cardTab = "CardBuilder-module--cardTab--9bde5";
export var ribbon = "CardBuilder-module--ribbon--46e26";
export var ribbonContent = "CardBuilder-module--ribbonContent--2bef5";